import { PhotoService } from './../../services/photo.service';
import { ActivatedRoute, Router } from '@angular/router';
import { RestService } from './../../services/rest.service';
import { Component, OnInit } from '@angular/core';
import {
  CameraResultType,
  CameraSource,
  ImageOptions,
  Photo,
} from '@capacitor/camera';
import { BackButtonService } from 'src/app/services/back-button.service';
import { SnackbarService } from '@bcl/design-system';
import { ViewWillEnter } from '@ionic/angular';

@Component({
  selector: 'app-new-item',
  templateUrl: './new-item.component.html',
  styleUrls: ['./new-item.component.scss'],
})
export class NewItemComponent implements OnInit, ViewWillEnter {
  chosenPicture: any;
  orderId: number;

  constructor(
    private rest: RestService,
    private router: Router,
    private route: ActivatedRoute,
    private camera: PhotoService,
    private backButtonService: BackButtonService,
    private snackbarService: SnackbarService
  ) {
    this.orderId = +this.route.snapshot.paramMap.get('id');
  }

  ngOnInit() {}

  ionViewWillEnter() {
    this.setupBackButton();
  }

  goBack() {
    this.router.navigate(['details', this.orderId]);
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad NewitemPage');
  }

  changePicture() {
    const options: ImageOptions = {
      quality: 100,
      resultType: CameraResultType.DataUrl,
      correctOrientation: false,
      allowEditing: false,
      height: 800,
      width: 800,
      source: CameraSource.Camera,
    };

    this.camera.getPhoto(options).then((imageData: Photo) => {
      this.chosenPicture = imageData.dataUrl;
      console.log('picture => ', imageData);
    });
  }

  savePhoto() {
    this.rest.savePhoto(this.orderId, this.chosenPicture);
    this.snackbarService.open('green', 'NEW_ITEM_PAGE.MESSAGES.PHOTO_SAVED');
    this.router.navigate(['details', this.orderId]);
  }

  private setupBackButton() {
    this.backButtonService.showBackButton({
      show: true,
      action: () => {
        this.goBack();
      },
    });
  }
}
